import PropTypes from 'prop-types';
import get from 'lodash/get';

const SANDBOX_RULES =
  'allow-same-origin allow-scripts allow-popups allow-forms allow-popups-to-escape-sandbox';

export default function WebPrompt({ guideItem }) {
  const { height, url } = get(guideItem, 'presentation', {});
  const heightToUse = height && parseInt(height, 10);
  if (!url || !heightToUse) {
    return null;
  }
  return (
    <iframe
      data-testid="webPrompt"
      height={heightToUse}
      width="100%"
      src={url}
      sandbox={SANDBOX_RULES}
      scrolling="no"
    />
  );
}

WebPrompt.propTypes = {
  guideItem: PropTypes.object.isRequired,
};
